import Swiper from "swiper"

class MAnnouncementBar extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.enableSlider = this.dataset.enableSlider === "true"
    this.enableMarquee = this.dataset.enableMarquee === "true"
    this.enableAutoplay = this.dataset.enableAutoplay === "true"
    this.autoplaySpeed = Number.parseInt(this.dataset.autoplaySpeed) * 1000
    this.blocksCount = Number.parseInt(this.dataset.blocksCount) || 1

    if (this.enableMarquee && !this.enableSlider) {
      this.initMarquee()
    }

    if (this.enableSlider && typeof Swiper !== "undefined") {
      this.initSlider()
    }

    this.setupLanguageSelector()
  }

  initMarquee() {
    const marquee = this.querySelector(".m-announcement-bar__marquee")

    if (marquee) {
      const innerElements = marquee.querySelectorAll(".m-announcement-bar__inner")
      const itemElements = marquee.querySelectorAll(".m-announcement-bar__item")

      let totalWidth = 0
      itemElements.forEach((item) => {
        totalWidth += item.offsetWidth + 40 // 40px gap
      })

      const marqueeWidth = marquee.offsetWidth
      const animationDuration = (totalWidth / marqueeWidth) * 20 // Calculate duration based on content width

      marquee.style.setProperty("--animation-duration", `${animationDuration}s`)
      marquee.style.setProperty("--blocks-count", this.blocksCount)
    }
  }

  initSlider() {
    const container = this.querySelector(".m-announcement-bar__wrapper.swiper-container")

    if (container) {
      new Swiper(container, {
        loop: true,
        autoplay: this.enableAutoplay
          ? {
              delay: this.autoplaySpeed,
              disableOnInteraction: false,
            }
          : false,
        navigation: {
          nextEl: ".m-announcement-bar__container .swiper-button-next",
          prevEl: ".m-announcement-bar__container .swiper-button-prev",
        },
        effect: "slide",
        speed: 800,
      })
    }
  }

  setupLanguageSelector() {
    const languageSelect = this.querySelector(".m-announcement-bar__language-select")
    if (languageSelect) {
      languageSelect.addEventListener("change", (e) => {
        const locale = e.target.value
        if (locale) {
          window.location.href = locale
        }
      })
    }
  }
}

customElements.define("m-announcement-bar", MAnnouncementBar)
